import React from 'react';
import EnterpriseNavbar from './EnterpriseNavbar';
import PopinNavbar from './PopinNavbar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isEnterpriseUrl, isPopinUrl, isPresentUrl, isNewDashboardUrl } from '../../Routes';
import NewDashboardNavbar from './NewDashboardNavbar';

class Navbar extends React.Component {

  render () {
    const { user, location } = this.props;
    if (!user) {
      // console.info('Navbar No user')
      return <PopinNavbar location={ location } />;
    } else if (isPresentUrl(location.pathname)) {
      // Hide nav on present page
      // console.info('Navbar Present page')
      return null;
    } else if (isNewDashboardUrl(location.pathname)) {
      // console.info('DashboardNavbar')
      return <NewDashboardNavbar location={ location } />
    } else if (isEnterpriseUrl(location.pathname)) {
      // console.info('EnterpriseNavbar')
      return <EnterpriseNavbar location={ location } />;
    } else if (isPopinUrl(location.pathname)) {
      // console.info('PopinNavbar')
      return <PopinNavbar location={ location } />;
    } else {
      // console.info('Navbar else')
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.user
  };
};

export default withRouter(connect(mapStateToProps, {})(Navbar));
